import React, { ReactNode } from 'react';
import { View } from '@react-pdf/renderer';
import { Card, Divider, ItemNameTitle, TextMid } from 'components/Pdf/PdfUI';
import { styles } from 'components/Pdf/PdfUI.styles';
import { theme } from 'styles';
import { textFormatter } from 'utils/format';
import { OrderPdfText } from './MyOrdersDetailPdfPage';

export interface TotalCardValues {
  priceVatExcluded?: string;
  priceVat?: string;
  priceVatIncluded?: string;
  currency?: string;
}

const TotalRow = ({
  isLastElement,
  label,
  data,
}: {
  isLastElement: boolean;
  label: ReactNode;
  data: string | undefined;
}) => {
  if (!data) {
    return null;
  }
  return (
    <>
      <View
        style={[
          styles.row,
          { width: '100%', height: 25, alignItems: 'center', justifyContent: 'space-between', padding: '0 5px' },
        ]}
      >
        <TextMid>{label}</TextMid>
        <TextMid>{data}</TextMid>
      </View>
      {!isLastElement && <Divider />}
    </>
  );
};

export const TotalCard = ({ text, values }: { text: OrderPdfText; values: TotalCardValues }) => {
  return (
    <Card
      title={<ItemNameTitle>{text.total}</ItemNameTitle>}
      height={100}
      width={160}
      noPadding
      titleBackgroundColor={theme.color.primary_brand_bg}
    >
      <View style={[styles.col]}>
        <TotalRow
          isLastElement={false}
          label={text.totalVatExcl}
          data={textFormatter.formatCurrency(Number(values.priceVatExcluded), values.currency)}
        />
        <TotalRow
          isLastElement={false}
          label={text.totalVat}
          data={textFormatter.formatCurrency(Number(values.priceVat), values.currency)}
        />
        <TotalRow
          isLastElement={true}
          label={text.totalVatIncl}
          data={textFormatter.formatCurrency(Number(values.priceVatIncluded), values.currency)}
        />
      </View>
    </Card>
  );
};
